import { graphql } from '@generated/gql';

export const FETCH_WORKFLOW_NAME = graphql(/** GraphQL */ `
  query workflowBreadcrumbFetchWorkflowName($workflowId: ObjectID!) {
    fetchWorkflow(workflowId: $workflowId) {
      workflow {
        name {
          ...WorkflowTranslatedString
        }
      }
    }
  }
`);
